var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-body-style",style:({'background-color':_vm.$store.state.corpInfo.darkTheme?'black':'#E2E6EF'})},[_c('NotFoundBody')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }